export const CHANGE_MENU_EXTENSION = 'CHANGE_MENU_EXTENSION';